import request from '@/utils/request';

const endpoints = {
    establishments: '/delivery/establishments',
    certainEstablishment: '/delivery/establishment',
    establishmentAddress: (establishmentId, addressId) => `/delivery/establishment/${establishmentId}/${addressId}`,
};

export default {
    getItems: async ({ dispatch, commit}, params) => {
        return request({
            url: endpoints.establishments,
            method: 'GET',
            params,
        }).then(res => {
            if (res.data) {
                commit('PROCESS_RES', res.data || []);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    },
    raiseEstablishment: async ({ dispatch }, id) => {
        return request({
            url: `${endpoints.certainEstablishment}/${id}/raise`,
            method: 'PATCH',
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },
    lowerEstablishment: async ({ dispatch }, id) => {
        return request({
            url: `${endpoints.certainEstablishment}/${id}/lower`,
            method: 'PATCH',
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },
    toggleAvailability({dispatch}, {newStatus, addressId, establishmentId}) {
        return request({
            url: endpoints.establishmentAddress(establishmentId, addressId),
            method: 'PUT',
            data: {status: newStatus}
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    }
};
